/* eslint-disable max-len */
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { ImageListItem } from './image-list-item';
import { ImageItemModelShape } from './item-model-shape';

const defaultItemWrapperStyle = {
  padding: '5px',
};

const defaultItemWrapper = props => (
  <div
    className="default-item-wrapper"
    style={defaultItemWrapperStyle}
  >
    {props.children}
  </div>
);

defaultItemWrapper.propTypes = {
  children: PropTypes.element.isRequired,
};

const Wrapper = (props) => {
  const {
    ItemWrapper,
    image,
    itemHeight,
    isSelected,
    onListItemClicked,
    onImageLoadError,
    imagePlaceHolderGetter,
    imagePlaceHolder,
    isOriginRatioUsed,
    isLazyLoadEnabled,
    index,
    i18n,
    onEscapeFromImage,
  } = props;
  const itemRef = useRef(null);
  const ariaLabel = isSelected ? `${i18n.getString('ImageExperience_SelectedImage')} ${index + 1}` : `${i18n.getString('ImageExperience_Image')} ${index + 1}`;
  return (
    <div className="image-list-item-wrapper" role="listitem" style={{ float: 'left' }}>
      <ItemWrapper
        image={image}
        itemHeight={itemHeight}
        isSelected={isSelected}
        itemRef={itemRef}
      >
        <ImageListItem
          image={image}
          onItemClicked={onListItemClicked}
          onImageLoadError={onImageLoadError}
          onEscapeFromImage={onEscapeFromImage}
          imagePlaceHolder={imagePlaceHolderGetter ? imagePlaceHolderGetter(image, index) : imagePlaceHolder}
          isLazyLoadEnabled={isLazyLoadEnabled}
          itemHeight={itemHeight}
          isOriginRatioUsed={isOriginRatioUsed}
          ariaLabel={ariaLabel}
          index={index}
          itemRef={itemRef}
        />
      </ItemWrapper>
    </div>
  );
};

Wrapper.propTypes = {
  image: ImageItemModelShape.isRequired,
  isSelected: PropTypes.bool.isRequired,
  isLazyLoadEnabled: PropTypes.bool,
  onListItemClicked: PropTypes.func,
  onImageLoadError: PropTypes.func,
  imagePlaceHolder: PropTypes.func,
  imagePlaceHolderGetter: PropTypes.func,
  itemHeight: PropTypes.number,
  isOriginRatioUsed: PropTypes.bool,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  index: PropTypes.number.isRequired,
  ItemWrapper: PropTypes.elementType.isRequired,
  onEscapeFromImage: PropTypes.func,
};

Wrapper.defaultProps = {
  onListItemClicked: _.noop,
  onImageLoadError: _.noop,
  isLazyLoadEnabled: true,
  imagePlaceHolder: null,
  imagePlaceHolderGetter: null,
  itemHeight: 250,
  isOriginRatioUsed: false,
  onEscapeFromImage: _.noop,
};

const ImageListView = (props) => {
  const ItemWrapper = props.imageListItemWrapper ? props.imageListItemWrapper : defaultItemWrapper;
  // eslint-disable-next-line no-unused-vars
  const itemRef = useRef(null);

  return (
    <div className="image-list-view" role="list" style={{ display: 'inline-block', width: '100%' }}>
      {
        props.imageList.map((image, index) => (
          <Wrapper
            ItemWrapper={ItemWrapper}
            image={image}
            itemHeight={props.itemHeight}
            isSelected={props.selectedIds.indexOf(image.id) >= 0}
            onListItemClicked={props.onListItemClicked}
            onImageLoadError={props.onImageLoadError}
            onEscapeFromImage={props.onEscapeFromImage}
            imagePlaceHolder={props.imagePlaceHolderGetter ? props.imagePlaceHolderGetter(image, index) : props.imagePlaceHolder}
            isLazyLoadEnabled={props.isLazyLoadEnabled}
            isOriginRatioUsed={props.isOriginRatioUsed}
            index={index}
            i18n={props.i18n}
            key={image.id}
          />
        ))
      }
    </div>
  );
};

ImageListView.propTypes = {
  imageList: PropTypes.arrayOf(ImageItemModelShape).isRequired,
  selectedIds: PropTypes.arrayOf(Number),
  isLazyLoadEnabled: PropTypes.bool,
  onListItemClicked: PropTypes.func,
  onImageLoadError: PropTypes.func,
  onEscapeFromImage: PropTypes.func,
  imageListItemWrapper: PropTypes.func,
  imagePlaceHolder: PropTypes.func,
  imagePlaceHolderGetter: PropTypes.func,
  itemHeight: PropTypes.number,
  isOriginRatioUsed: PropTypes.bool,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};

ImageListView.defaultProps = {
  onListItemClicked: _.noop,
  onImageLoadError: _.noop,
  onEscapeFromImage: _.noop,
  selectedIds: [],
  isLazyLoadEnabled: true,
  imageListItemWrapper: null,
  imagePlaceHolder: null,
  imagePlaceHolderGetter: null,
  itemHeight: 250,
  isOriginRatioUsed: false,
};

export { ImageListView };
